/**
 * As duas conversões que todo formulário de janela faz na borda.
 *
 * Viviam copiadas em cada tela que abriu uma janela de edição — com o mesmo
 * corpo e o mesmo comentário — e a terceira cópia mostrou que pertencem a um
 * lugar só: é aqui que se decide o que "campo vazio" significa para a API.
 */

/** Campo vazio significa apagar o que estava lá, e a API aceita nulo. */
export function ler(campos: FormData, nome: string): string | null {
  return String(campos.get(nome) ?? '').trim() || null;
}

/** Data em ISO para o formato que o `input[type=date]` entende. */
export function dia(iso: string | null | undefined): string {
  return iso ? iso.slice(0, 10) : '';
}
